<template>
    <section>
        Nie znaleziono
    </section>
</template>
<script>
export default {
    mounted() {
        console.log('Component mounted.')
    }
}
</script>